import { Divider, Drawer, Input } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import CSS from "../../../utils/CSS";
import Html from "../../../utils/Html";
import { tt_name_block_warning } from "../../../utils/Utils";

export default function Custom(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [content, setContent] = useState(props.content);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }
    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
       html = "",
       css = ""
    } = data;

    const save = () => {
        if(!name){
            let _name = prompt(tt_name_block_warning);
            if(_name){
                close();
                saveItem(id, { ...content, "name" : _name });
            } else {
                return; 
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const drawRender = () => {
        return(
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
            <CSS html={css} />
            <Html html={html} />
            </div>
        )
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CSS</Divider>
                <Input.TextArea placeholder="CSS..." style={{"fontSize" : "11px"}} value={css} onChange={(e) => setData({ ...data, "css": e.target.value })} rows={8} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HTML</Divider>
                <Input.TextArea placeholder="HTML..."  style={{"fontSize" : "11px"}} value={html} onChange={(e) => setData({ ...data, "html": e.target.value })} rows={8} />
                <div className="shim" /> <div className="shim" />
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX" : "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}